import { LandingPageSectionPosition } from '@/network/graphql.g'

export const getImageUrlManufacturer = (position: string): string => {
  let imageUrl: string
  switch (position) {
    case LandingPageSectionPosition.Center4:
      imageUrl =
        'https://i.factcool.com/blackFriday/desktop_1_banner_trendyol.jpg'
      break
    case LandingPageSectionPosition.Center5:
      imageUrl = 'https://i.factcool.com/blackFriday/desktop_2_banner_ombre.jpg'
      break
    case LandingPageSectionPosition.Center6:
      imageUrl =
        'https://i.factcool.com/blackFriday/desktop_3_banner_lee_cooper.jpg'
      break
    case LandingPageSectionPosition.Center7:
      imageUrl =
        'https://i.factcool.com/blackFriday/desktop_4_banner_dstreet.jpg'
      break
  }
  return imageUrl
}

export const getImageUrlMobileManufacturer = (position: string): string => {
  let imageUrl: string
  switch (position) {
    case LandingPageSectionPosition.Center4:
      imageUrl =
        'https://i.factcool.com/blackFriday/mobile_1_banner_trendyol.jpg'
      break
    case LandingPageSectionPosition.Center5:
      imageUrl = 'https://i.factcool.com/blackFriday/mobile_2_banner_ombre.jpg'
      break
    case LandingPageSectionPosition.Center6:
      imageUrl =
        'https://i.factcool.com/blackFriday/mobile_3_banner_lee_cooper.jpg'
      break
    case LandingPageSectionPosition.Center7:
      imageUrl =
        'https://i.factcool.com/blackFriday/mobile_4_banner_dstreet_new.jpg'
      break
  }
  return imageUrl
}
